module.exports = __webpack_public_path__ + "static/team-1387dc756a8161acaf6658f8cf81d300.png";